import { Types } from "../Constants/Types";
import { CartState } from "../Interfaces/cart-interface";

const initialState: CartState = {
  cart: null,
  loading: false,
  error: null
};

const CustomerCartReducer = (state: CartState = initialState, action: any) => {
  switch (action.type) {
    case Types.FETCH_CUSTOMER_CART:
      return {
        ...state,
        cart: action.payload
      };

    case Types.CREATE_CART_ITEM:
    case Types.ADD_ITEM_TO_CART:
    case Types.INCREASE_CART_ITEM_QUANTITY:
    case Types.DECREASE_CART_ITEM_QUANTITY:
    case Types.TOGGLE_SELECTED_CART_ITEM:
    case Types.REMOVE_CART_ITEM:
    case Types.REMOVE_CART_ITEMS:
      return state;

    case Types.START_CUSTOMER_CART:
      return {
        ...state,
        loading: true,
        error: null
      };

    case Types.END_CUSTOMER_CART:
      return {
        ...state,
        loading: false
      };

    case Types.ERROR_CUSTOMER_CART:
      return {
        ...state,
        error: action.payload
      };

    case Types.RESET_CUSTOMER_CART:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};

export default CustomerCartReducer; 